module.exports = __webpack_public_path__ + "static/img/perfil-de-amostra.8d5c12ac.png";